export const testimonialsData = [
    {
      id: 1,
      name: "Julia Yatsenko",
      title: "System Analyst",
      img:
        "assets/Julia.jpeg",
      icon: "assets/linkedin.png",
      url: "https://www.linkedin.com/in/julia-yatsenko/",
      desc:
        `" Arsen is an expert at taking innovative ideas and turning them into solutions. "`,
    },

    {
      id: 2,
      name: "Anton Zyhar",
      title: "Senior Developer",
      img:
        "assets/Anton.jpeg",
      icon: "assets/linkedin.png",
      url: "https://www.linkedin.com/in/anton-zyhar-03547612a/",
      desc:
        `" Arsen is always a team player, works well with everyone, and makes sure everyone feels comfortable on the task. "`,
      featured: true,
    },
    
    {
      id: 3,
      name: "Georgii Trevgoda",
      title: "Entrepreneur",
      img:
        "assets/Gosha.jpeg",
      icon: "assets/linkedin.png",
      url: "https://www.linkedin.com/in/georgii-trevgoda-8b0864201/",
      desc:
        `" This guy sticks out among everyone when it comes to facing tough problems and providing solutions to them. "`,
    },
  ];